import { Reveal, Overline } from "./Reveal";
import { useLang } from "@/i18n";
import { IMAGES } from "@/data";
import { ArrowUpRight } from "lucide-react";

export const Departures = () => {
  const { t } = useLang();
  const ports = t("departures.ports");
  const imgs = { montreal: IMAGES.montreal, toronto: IMAGES.portAerial };
  return (
    <section className="py-32 bg-surface/40 border-y border-white/10" data-testid="departures-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <Overline>{t("departures.overline")}</Overline>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">{t("departures.title")}</h2>
        </Reveal>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          {ports.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.15}>
              <div className="group relative overflow-hidden border border-white/10 bg-surface" data-testid={`departure-${p.img}`}>
                <div className="overflow-hidden aspect-[16/9]">
                  <img src={imgs[p.img]} alt={p.name} loading="lazy" decoding="async"
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-abyss via-abyss/30 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <p className="text-xs font-bold tracking-[0.2em] uppercase text-ember mb-2">{p.tag}</p>
                  <div className="flex items-center justify-between">
                    <h3 className="font-display text-3xl lg:text-4xl font-bold uppercase tracking-tight">{p.name}</h3>
                    <ArrowUpRight className="text-steel-500 group-hover:text-ember transition-colors duration-300" />
                  </div>
                  <p className="mt-3 text-sm text-steel-300 leading-relaxed max-w-md">{p.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
